/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BeginPaymentRequest,
    BeginPaymentRequestFromJSON,
    BeginPaymentRequestToJSON,
    CheckoutSessionResponse,
    CheckoutSessionResponseFromJSON,
    CheckoutSessionResponseToJSON,
    EducationAnswer,
    EducationAnswerFromJSON,
    EducationAnswerToJSON,
    ExerciseDetailsAnswer,
    ExerciseDetailsAnswerFromJSON,
    ExerciseDetailsAnswerToJSON,
    HomeAnswer,
    HomeAnswerFromJSON,
    HomeAnswerToJSON,
    OrganizationDetails,
    OrganizationDetailsFromJSON,
    OrganizationDetailsToJSON,
    ProgramVideosAnswer,
    ProgramVideosAnswerFromJSON,
    ProgramVideosAnswerToJSON,
    RegisterPostBody,
    RegisterPostBodyFromJSON,
    RegisterPostBodyToJSON,
    StatisticsAnswer,
    StatisticsAnswerFromJSON,
    StatisticsAnswerToJSON,
    SurveyPostBody,
    SurveyPostBodyFromJSON,
    SurveyPostBodyToJSON,
    SurveyResponse,
    SurveyResponseFromJSON,
    SurveyResponseToJSON,
    UserAnswer,
    UserAnswerFromJSON,
    UserAnswerToJSON,
    VersionOutput,
    VersionOutputFromJSON,
    VersionOutputToJSON,
    VideoDetailsAnswer,
    VideoDetailsAnswerFromJSON,
    VideoDetailsAnswerToJSON,
    VideoEventPostBody,
    VideoEventPostBodyFromJSON,
    VideoEventPostBodyToJSON,
    VideoExercisesAnswer,
    VideoExercisesAnswerFromJSON,
    VideoExercisesAnswerToJSON,
} from '../models';

export interface BeginPaymentPostRequest {
    body: BeginPaymentRequest;
}

export interface EducationalvideosGetRequest {
    token: string;
}

export interface ExerciseDetailsGetRequest {
    token: string;
    exerciseId: number;
}

export interface ExercisesGetRequest {
    token: string;
    videoId: number;
}

export interface HomeGetRequest {
    token: string;
    now: string;
}

export interface OrganizationDetailsGetRequest {
    organizationId?: number;
    organizationSlug?: string;
}

export interface RegisterPostRequest {
    body: RegisterPostBody;
}

export interface StatisticsGetRequest {
    token: string;
    now: string;
}

export interface StripeWebhookPostRequest {
    body: object;
}

export interface SurveyPostRequest {
    token: string;
    body: SurveyPostBody;
}

export interface UserGetRequest {
    token: string;
}

export interface VerifyRegistrationCodeGetRequest {
    registrationCode: string;
}

export interface VideoDetailsGetRequest {
    token: string;
    videoId: number;
}

export interface VideoEventPostRequest {
    token: string;
    body: VideoEventPostBody;
}

export interface VideosGetRequest {
    token: string;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Begin the payment workflow for the app; once the workflow is completed, a sign-up link will be emailed to the user.
     */
    async beginPaymentPostRaw(requestParameters: BeginPaymentPostRequest): Promise<runtime.ApiResponse<CheckoutSessionResponse>> {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling beginPaymentPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/begin-payment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BeginPaymentRequestToJSON(requestParameters.body),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckoutSessionResponseFromJSON(jsonValue));
    }

    /**
     * Begin the payment workflow for the app; once the workflow is completed, a sign-up link will be emailed to the user.
     */
    async beginPaymentPost(requestParameters: BeginPaymentPostRequest): Promise<CheckoutSessionResponse> {
        const response = await this.beginPaymentPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get educational content
     */
    async educationalvideosGetRaw(requestParameters: EducationalvideosGetRequest): Promise<runtime.ApiResponse<EducationAnswer>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling educationalvideosGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.token !== undefined && requestParameters.token !== null) {
            headerParameters['token'] = String(requestParameters.token);
        }

        const response = await this.request({
            path: `/educationalvideos`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EducationAnswerFromJSON(jsonValue));
    }

    /**
     * Get educational content
     */
    async educationalvideosGet(requestParameters: EducationalvideosGetRequest): Promise<EducationAnswer> {
        const response = await this.educationalvideosGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get information for one specific exercise
     */
    async exerciseDetailsGetRaw(requestParameters: ExerciseDetailsGetRequest): Promise<runtime.ApiResponse<ExerciseDetailsAnswer>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling exerciseDetailsGet.');
        }

        if (requestParameters.exerciseId === null || requestParameters.exerciseId === undefined) {
            throw new runtime.RequiredError('exerciseId','Required parameter requestParameters.exerciseId was null or undefined when calling exerciseDetailsGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.token !== undefined && requestParameters.token !== null) {
            headerParameters['token'] = String(requestParameters.token);
        }

        const response = await this.request({
            path: `/exercise-details`.replace(`{${"exercise-id"}}`, encodeURIComponent(String(requestParameters.exerciseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ExerciseDetailsAnswerFromJSON(jsonValue));
    }

    /**
     * Get information for one specific exercise
     */
    async exerciseDetailsGet(requestParameters: ExerciseDetailsGetRequest): Promise<ExerciseDetailsAnswer> {
        const response = await this.exerciseDetailsGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get all exercises in a specific video
     */
    async exercisesGetRaw(requestParameters: ExercisesGetRequest): Promise<runtime.ApiResponse<VideoExercisesAnswer>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling exercisesGet.');
        }

        if (requestParameters.videoId === null || requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId','Required parameter requestParameters.videoId was null or undefined when calling exercisesGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.token !== undefined && requestParameters.token !== null) {
            headerParameters['token'] = String(requestParameters.token);
        }

        const response = await this.request({
            path: `/exercises`.replace(`{${"video-id"}}`, encodeURIComponent(String(requestParameters.videoId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VideoExercisesAnswerFromJSON(jsonValue));
    }

    /**
     * Get all exercises in a specific video
     */
    async exercisesGet(requestParameters: ExercisesGetRequest): Promise<VideoExercisesAnswer> {
        const response = await this.exercisesGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get the information displayed on Home screen
     */
    async homeGetRaw(requestParameters: HomeGetRequest): Promise<runtime.ApiResponse<HomeAnswer>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling homeGet.');
        }

        if (requestParameters.now === null || requestParameters.now === undefined) {
            throw new runtime.RequiredError('now','Required parameter requestParameters.now was null or undefined when calling homeGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.now !== undefined) {
            queryParameters['now'] = requestParameters.now;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.token !== undefined && requestParameters.token !== null) {
            headerParameters['token'] = String(requestParameters.token);
        }

        const response = await this.request({
            path: `/home`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => HomeAnswerFromJSON(jsonValue));
    }

    /**
     * Get the information displayed on Home screen
     */
    async homeGet(requestParameters: HomeGetRequest): Promise<HomeAnswer> {
        const response = await this.homeGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get information about a particular organization.
     */
    async organizationDetailsGetRaw(requestParameters: OrganizationDetailsGetRequest): Promise<runtime.ApiResponse<OrganizationDetails>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.organizationId !== undefined) {
            queryParameters['organization-id'] = requestParameters.organizationId;
        }

        if (requestParameters.organizationSlug !== undefined) {
            queryParameters['organization-slug'] = requestParameters.organizationSlug;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/organization-details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationDetailsFromJSON(jsonValue));
    }

    /**
     * Get information about a particular organization.
     */
    async organizationDetailsGet(requestParameters: OrganizationDetailsGetRequest): Promise<OrganizationDetails> {
        const response = await this.organizationDetailsGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Return spreadsheet data for the programs, in a zip file.
     */
    async programDataGetRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/program-data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Return spreadsheet data for the programs, in a zip file.
     */
    async programDataGet(): Promise<void> {
        await this.programDataGetRaw();
    }

    /**
     * Register a user
     */
    async registerPostRaw(requestParameters: RegisterPostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling registerPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("OAuth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/register`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterPostBodyToJSON(requestParameters.body),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Register a user
     */
    async registerPost(requestParameters: RegisterPostRequest): Promise<void> {
        await this.registerPostRaw(requestParameters);
    }

    /**
     * Get user statistics
     */
    async statisticsGetRaw(requestParameters: StatisticsGetRequest): Promise<runtime.ApiResponse<StatisticsAnswer>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling statisticsGet.');
        }

        if (requestParameters.now === null || requestParameters.now === undefined) {
            throw new runtime.RequiredError('now','Required parameter requestParameters.now was null or undefined when calling statisticsGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.now !== undefined) {
            queryParameters['now'] = requestParameters.now;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.token !== undefined && requestParameters.token !== null) {
            headerParameters['token'] = String(requestParameters.token);
        }

        const response = await this.request({
            path: `/statistics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => StatisticsAnswerFromJSON(jsonValue));
    }

    /**
     * Get user statistics
     */
    async statisticsGet(requestParameters: StatisticsGetRequest): Promise<StatisticsAnswer> {
        const response = await this.statisticsGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Called by Stripe to report payment events.
     */
    async stripeWebhookPostRaw(requestParameters: StripeWebhookPostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling stripeWebhookPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/stripe-webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Called by Stripe to report payment events.
     */
    async stripeWebhookPost(requestParameters: StripeWebhookPostRequest): Promise<void> {
        await this.stripeWebhookPostRaw(requestParameters);
    }

    /**
     * Start a survey, submit partial survey state and get the next part of the survey, or submit completed survey and get a response with survey score.
     */
    async surveyPostRaw(requestParameters: SurveyPostRequest): Promise<runtime.ApiResponse<SurveyResponse>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling surveyPost.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling surveyPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.token !== undefined && requestParameters.token !== null) {
            headerParameters['token'] = String(requestParameters.token);
        }

        const response = await this.request({
            path: `/survey`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SurveyPostBodyToJSON(requestParameters.body),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SurveyResponseFromJSON(jsonValue));
    }

    /**
     * Start a survey, submit partial survey state and get the next part of the survey, or submit completed survey and get a response with survey score.
     */
    async surveyPost(requestParameters: SurveyPostRequest): Promise<SurveyResponse> {
        const response = await this.surveyPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get user information
     */
    async userGetRaw(requestParameters: UserGetRequest): Promise<runtime.ApiResponse<UserAnswer>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling userGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.token !== undefined && requestParameters.token !== null) {
            headerParameters['token'] = String(requestParameters.token);
        }

        const response = await this.request({
            path: `/user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserAnswerFromJSON(jsonValue));
    }

    /**
     * Get user information
     */
    async userGet(requestParameters: UserGetRequest): Promise<UserAnswer> {
        const response = await this.userGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Verify registration code
     */
    async verifyRegistrationCodeGetRaw(requestParameters: VerifyRegistrationCodeGetRequest): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.registrationCode === null || requestParameters.registrationCode === undefined) {
            throw new runtime.RequiredError('registrationCode','Required parameter requestParameters.registrationCode was null or undefined when calling verifyRegistrationCodeGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.registrationCode !== undefined) {
            queryParameters['registration-code'] = requestParameters.registrationCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/verify-registration-code`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Verify registration code
     */
    async verifyRegistrationCodeGet(requestParameters: VerifyRegistrationCodeGetRequest): Promise<object> {
        const response = await this.verifyRegistrationCodeGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Show API version
     */
    async versionGetRaw(): Promise<runtime.ApiResponse<VersionOutput>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/version`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VersionOutputFromJSON(jsonValue));
    }

    /**
     * Show API version
     */
    async versionGet(): Promise<VersionOutput> {
        const response = await this.versionGetRaw();
        return await response.value();
    }

    /**
     * Get detailed information on one video
     */
    async videoDetailsGetRaw(requestParameters: VideoDetailsGetRequest): Promise<runtime.ApiResponse<VideoDetailsAnswer>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling videoDetailsGet.');
        }

        if (requestParameters.videoId === null || requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId','Required parameter requestParameters.videoId was null or undefined when calling videoDetailsGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.token !== undefined && requestParameters.token !== null) {
            headerParameters['token'] = String(requestParameters.token);
        }

        const response = await this.request({
            path: `/video-details`.replace(`{${"video-id"}}`, encodeURIComponent(String(requestParameters.videoId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VideoDetailsAnswerFromJSON(jsonValue));
    }

    /**
     * Get detailed information on one video
     */
    async videoDetailsGet(requestParameters: VideoDetailsGetRequest): Promise<VideoDetailsAnswer> {
        const response = await this.videoDetailsGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * After user has watched all or part of a video, post info about the user-video-event to the backend for tracking.
     */
    async videoEventPostRaw(requestParameters: VideoEventPostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling videoEventPost.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling videoEventPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.token !== undefined && requestParameters.token !== null) {
            headerParameters['token'] = String(requestParameters.token);
        }

        const response = await this.request({
            path: `/video-event`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VideoEventPostBodyToJSON(requestParameters.body),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * After user has watched all or part of a video, post info about the user-video-event to the backend for tracking.
     */
    async videoEventPost(requestParameters: VideoEventPostRequest): Promise<void> {
        await this.videoEventPostRaw(requestParameters);
    }

    /**
     * Gets all of the videos for the user\'s \'my program\' screen.
     */
    async videosGetRaw(requestParameters: VideosGetRequest): Promise<runtime.ApiResponse<ProgramVideosAnswer>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling videosGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.token !== undefined && requestParameters.token !== null) {
            headerParameters['token'] = String(requestParameters.token);
        }

        const response = await this.request({
            path: `/videos`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramVideosAnswerFromJSON(jsonValue));
    }

    /**
     * Gets all of the videos for the user\'s \'my program\' screen.
     */
    async videosGet(requestParameters: VideosGetRequest): Promise<ProgramVideosAnswer> {
        const response = await this.videosGetRaw(requestParameters);
        return await response.value();
    }

}
